import React from 'react';

import { FeaturedPartner } from '../../interfaces/homepage';
import { SectionTitle } from './SectionTitle';

interface FeaturedPartnersProps {
  featuredPartners: FeaturedPartner[];
}

const FeaturedPartners = ({ featuredPartners }: FeaturedPartnersProps) => {
  return (
    <div className="mb-80 lg:mb-90">
      <SectionTitle title="Featured Partners" />
      {featuredPartners.map(({ tagline, name, targetLink }, index) => (
        <div key={`${name}-${index}`} className="mb-32 last:mb-0">
          <h2 className="mb-4 mt-0 font-suisse-neue text-body-md text-primary-black lg:text-subheadline-sm">
            <a href={targetLink} className="text-inherit hover:text-primary-magenta">
              {name}
            </a>
          </h2>
          <p className="m-0 font-suisse-screen text-disclosure-md text-primary-black">{tagline}</p>
        </div>
      ))}
    </div>
  );
};

export default FeaturedPartners;
